import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { SaldoVendedorService } from '../../services/saldo-vendedor.service';
import { SaldoMotoristaService } from '../../services/saldo-motorista.service';

interface SaqueItem {
  id: string;
  valorSolicitado: number;
  valorEfetivamentePago?: number;
  status: string;
  metodoRecebimento: string;
  saqueManualSemTaxa: boolean;
  dataSolicitacao: string;
  dataAprovacao?: string;
  dataPagamento?: string;
}

@Component({
  selector: 'app-withdrawal-history',
  templateUrl: './withdrawal-history.page.html',
  styleUrls: ['./withdrawal-history.page.scss'],
  standalone: false,
})
export class WithdrawalHistoryPage implements OnInit {
  items: SaqueItem[] = [];
  loading = false;
  isCaller = true;

  constructor(
    private saldoVendedor: SaldoVendedorService,
    private saldoMotorista: SaldoMotoristaService,
    private loadCtrl: LoadingController,
    private storage: Storage,
  ) {}

  async ngOnInit() {
    const userType = await this.storage.get('userType');
    this.isCaller = (userType ?? '').toLowerCase() !== 'driver';
    await this.load();
  }

  ionViewWillEnter() {
    this.load();
  }

  async load() {
    this.loading = true;
    const loading = await this.loadCtrl.create({ message: 'Loading...' });
    await loading.present();
    const obs = this.isCaller
      ? this.saldoVendedor.listMyWithdrawals()
      : this.saldoMotorista.listMyWithdrawals();
    obs.subscribe({
      next: (res: any) => {
        this.items = Array.isArray(res) ? res : (res?.data ?? []);
        this.loading = false;
        loading.dismiss();
      },
      error: () => { this.loading = false; loading.dismiss(); },
    });
  }

  statusColor(status: string): string {
    switch ((status || '').toUpperCase()) {
      case 'PAGA': return 'success';
      case 'APROVADA': return 'tertiary';
      case 'REJEITADA':
      case 'CANCELADA': return 'danger';
      default: return 'warning';
    }
  }
}
